import { HTTPError } from 'ky'

export function isAuthError(error: unknown) {
  return error instanceof HTTPError && error.response.status === 401
}
